import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const INIT = 'ryvuss/INIT';
export const init = createAction(INIT);

const RESET = 'ryvuss/RESET';
export const reset = createAction(RESET);

const GET_RYVUSS = 'ryvuss/GET_RYVUSS';
export const getRyvuss = createAction(GET_RYVUSS, api.getRyvuss);

const GET_HOT_MANUFACT = 'ryvuss/GET_HOT_MANUFACT';
export const getHotManufact = createAction(GET_HOT_MANUFACT, api.getRyvuss);

const CHANGE_HOT = 'ryvuss/CHANGE_HOT';
export const changeHot = createAction(CHANGE_HOT);

const initialState = {
	isInit: false,
	nav: [],
	manufacturer: {},
	manufacturerY: [],
	manufacturerN: [],
	category: {},
	year: {},
	model: [],
	badgeGroup: {},
	hot: [],
};

export default handleActions(
	{
		[INIT]: (state, action) =>
			produce(state, (draft) => {
				draft.isInit = action.payload || false;
			}),

		[RESET]: () => ({
			isInit: false,
			nav: [],
			manufacturer: {},
			manufacturerY: [],
			manufacturerN: [],
			category: {},
			year: {},
			model: [],
			badgeGroup: {},
			hot: [],
		}),

		[CHANGE_HOT]: (state) =>
			produce(state, (draft) => {
				const { hot, manufacturerN } = state;
				const resultHot = hot.map((item) => {
					const same = manufacturerN.filter((child) => child.Value === item.Value)[0];
					return {
						...item,
						IsSelected: same.IsSelected,
						Action: same.Action,
						Count: same.Count,
					};
				});

				draft.hot = resultHot || [];
			}),

		...pender({
			type: GET_RYVUSS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { Nodes: nav } = data.iNav;
					const { Nodes: target } =
						nav.filter((item) => item.Name === 'ModelCarType')[0].Facets.filter((item) => item.IsSelected)[0]?.Refinements || {};
					const manufacturer = target?.filter((item) => item.Name === 'MultiManufacturer')[0];
					const manufacturerY = manufacturer?.Facets.filter((item) => item.Metadata.CarType[0] === 'Y');
					const manufacturerN = manufacturer?.Facets.filter((item) => item.Metadata.CarType[0] === 'N');
					const { Facets } = target?.filter((item) => item.Name === 'ModelPath')[0] || {};
					const category = nav.filter((item) => item.Name === 'Category')[0];
					const year = nav.filter((item) => item.Name === 'Year')[0];
					const model = Facets?.map((item, index) => ({
						...item,
						cnt: index,
					}));
					const selectedModel = Facets?.filter((item) => item.IsSelected)[0];
					const badgeGroup = selectedModel ? selectedModel.Refinements.Nodes[0] : {};

					draft.nav = nav || [];
					draft.manufacturer = manufacturer || {};
					draft.manufacturerY = manufacturerY || [];
					draft.manufacturerN = manufacturerN || [];
					draft.category = category || {};
					draft.year = year || {};
					draft.model = model || [];
					draft.badgeGroup = badgeGroup || {};
				}),
		}),

		...pender({
			type: GET_HOT_MANUFACT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { manufacturerN } = state;
					const { Nodes: nav } = data.iNav;
					const { Nodes: target } = nav
						.filter((item) => item.Name === 'CarType')[0]
						.Facets.filter((item) => item.IsSelected)[0].Refinements;
					const { Facets } = target.filter((item) => item.Name === 'Manufacturer')[0];
					const sorting = (arr) =>
						arr.sort((a, b) => {
							if (a.Count < b.Count) return 1;
							if (a.Count > b.Count) return -1;
							return 0;
						});
					const hot = sorting(Facets);

					const resultHot = hot.slice(0, 7).map((item) => {
						const same = manufacturerN.filter((child) => child.Value === item.Value)[0];
						return {
							...item,
							IsSelected: same.IsSelected,
							Action: same.Action,
							Count: same.Count,
						};
					});

					draft.hot = resultHot || [];
				}),
		}),
	},
	initialState,
);
